<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { contactDtoFields } from "../../utils/TableFields/contact-dto.fields";

  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    search,
    tableCustomFields,
  } from "./contact.store";

  $: tableFields = [...contactDtoFields, ...$tableCustomFields];

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="contatto"
    entityPlural="contatti"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  />

  <Table
    loading={$loading}
    fields={tableFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
